"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_env_scopes_1 = __importDefault(require("../enums/model-env-scopes"));
const model_scopes_1 = __importDefault(require("../enums/model-scopes"));
const GraphandFieldRelation_1 = __importDefault(require("../lib/fields/GraphandFieldRelation"));
const GraphandFieldText_1 = __importDefault(require("../lib/fields/GraphandFieldText"));
const GraphandModel_1 = __importDefault(require("../lib/GraphandModel"));
const decorators_1 = require("../utils/decorators");
/**
 * @class Account
 * @augments GraphandModel
 * @classdesc Account model. Use {@link GraphandClient#getModel client.getModel("Account")} to use this model
 */
class Account extends GraphandModel_1.default {
    get fullname() {
        return `${this.firstname} ${this.lastname}`;
    }
    /**
     * Get accessToken with credentials & set token to {@link GraphandClient}
     * @param credentials {Object} - Credentials sent to api
     */
    static async login(credentials) {
        return this._client.login(credentials);
    }
    static clearCache() {
        GraphandModel_1.default.clearCache.apply(this, arguments);
        this._currentId = undefined;
        return this;
    }
    /**
     * Register new account
     * @param payload {Object}
     * @param hooks {boolean=}
     */
    static register(payload, hooks = true) {
        return this.create(payload, hooks, `auth/register`);
    }
    /**
     * [admin only] Generate a new token for account with id
     * @param id {string}
     * @returns {string}
     */
    static async generateToken(id) {
        const { data: { data }, } = await this._client._axios.post(`accounts/${id}/generate-token`);
        return data;
    }
    /**
     * Returns current account
     * @param populate {boolean=}. If false, returns only the current account id
     * @param opts
     * @returns {Account}
     */
    static async getCurrent(populate = true, opts = {}) {
        if (!this._currentId) {
            const _opts = Object.assign({}, typeof populate === "object" ? populate : {}, opts);
            const account = await this.get(Object.assign(Object.assign({}, _opts), { query: { _id: "current" } }));
            this._currentId = (account === null || account === void 0 ? void 0 : account._id) || null;
        }
        const id = await this._currentId;
        if (populate) {
            return id && (await this.get({ query: { _id: id } }));
        }
        return id;
    }
    /**
     * [admin only] Generate a new token for current account
     */
    async generateToken() {
        const { constructor } = Object.getPrototypeOf(this);
        return await constructor.generateToken(this._id);
    }
}
Account._customFields = {};
Account.queryFields = true;
Account.apiIdentifier = "accounts";
Account.baseUrl = "/accounts";
Account.scope = model_scopes_1.default.Account;
Account.envScope = model_env_scopes_1.default.ENV;
Account.schema = {
    firstname: new GraphandFieldText_1.default(),
    lastname: new GraphandFieldText_1.default(),
    email: new GraphandFieldText_1.default(),
    password: new GraphandFieldText_1.default(),
    role: new GraphandFieldRelation_1.default({ ref: "Role", multiple: false }),
};
Account._currentId = undefined;
__decorate([
    (0, decorators_1.ownProperty)(),
    __metadata("design:type", Object)
], Account, "_currentId", void 0);
exports.default = Account;
